import { render, staticRenderFns } from "./BranchIncomeReport.vue?vue&type=template&id=1f76556c&scoped=true"
import script from "./BranchIncomeReport.vue?vue&type=script&lang=js"
export * from "./BranchIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76556c",
  null
  
)

export default component.exports